export default __webpack_public_path__ + "static/media/WyattKelly.ed945677.jpg";